import axios from './axiosConfig'

export const allSample = async () => {
  const response = await axios.get('/sample')
  console.log(response.data)
  return response.data
}

export const getSampleById = async (id) => {
  const response = await axios.get(`/sample/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const createSample = async (formData) => {
  const data = new FormData()

  data.append('title', formData.title)

  if (formData.pdf && formData.pdf[0]) {
    data.append('pdf', formData.pdf[0])
  }

  try {
    const response = await axios.post('/sample', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error creating sample:', error)
    throw error
  }
}

export const updateSample = async (id, formData) => {
  const data = new FormData()

  data.append('title', formData.title)

  // Only append pdf if a new one is provided
  if (formData.pdf && formData.pdf[0]) {
    data.append('pdf', formData.pdf[0])
  }

  console.log('update sample', data)
  try {
    const response = await axios.put(`/sample/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error updating sample:', error)
    throw error
  }
}

export const deleteSample = async (id, otp) => {
  try {
    const response = await axios.delete(`/sample/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete sample response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting sample:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/sample/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}
